<div class="legend">
    <div class="legend-header">
        <div>
            Route Status
        </div>
        <button mat-icon-button
                class="configure-button"
                (click)="openConfiguration()"
                matTooltip="Configure Route Status Map"
        >
            <mat-icon>settings</mat-icon>
        </button>
    </div>
    <div class="legend-subtitle">
        <span>Service status of routes</span>
    </div>
    <div class="legend-line">
        <div class="legend-item__wrapper">
            <app-line-dash-array-view
              [dashArray]="userTrackStyles.routeStatusServiced.dasharray"
              [color]="userTrackStyles.routeStatusServiced.color"
            ></app-line-dash-array-view>

            <div class="legend-item__name">
                Serviced
            </div>
        </div>
        <div class="legend-item__wrapper">
          <app-line-dash-array-view
            [dashArray]="userTrackStyles.routeStatusInProgress.dasharray"
            [color]="userTrackStyles.routeStatusInProgress.color"
          ></app-line-dash-array-view>

            <div class="legend-item__name">
                In Progress
            </div>
        </div>
        <div class="legend-item__wrapper">
          <app-line-dash-array-view
            [dashArray]="userTrackStyles.routeStatusNotServiced.dasharray"
            [color]="userTrackStyles.routeStatusNotServiced.color"
          ></app-line-dash-array-view>

            <div class="legend-item__name">
                Not Serviced
            </div>
        </div>
    </div>
</div>
